import { fromUnixTime } from 'date-fns';

import { SPECIAL_DATE_RANGES } from '/src/features/_global/constants';
import { JSON_DATE_RANGE_ADAPTER } from '/src/utils/date-range-adapters';

const VALID_AB_TEST_SPECIAL_DATE_RANGES = new Set(Object.values(SPECIAL_DATE_RANGES));
const DEFAULT_AB_TEST_DATE_SELECTION = {
  special: 'default',
  startDate: null,
  endDate: null,
};

export function getDefaultAbTestDateSelection() {
  return { ...DEFAULT_AB_TEST_DATE_SELECTION };
}

export function isValidAbTestSpecialDateRange(special) {
  return VALID_AB_TEST_SPECIAL_DATE_RANGES.has(special);
}

export function parseAbTestSelectedDateRangeParam(dateRange) {
  const parsed = JSON_DATE_RANGE_ADAPTER.parse(dateRange);

  if (parsed.status === 'missing') {
    return {
      isValid: true,
      selection: getDefaultAbTestDateSelection(),
    };
  }

  if (parsed.status !== 'valid') {
    return {
      isValid: false,
      selection: getDefaultAbTestDateSelection(),
    };
  }

  if (parsed.value.special) {
    return {
      isValid: true,
      selection: {
        special: parsed.value.special,
        startDate: null,
        endDate: null,
      },
    };
  }

  return {
    isValid: true,
    selection: {
      special: null,
      startDate: Math.floor(parsed.value.start_date.getTime() / 1000),
      endDate: Math.floor(parsed.value.end_date.getTime() / 1000),
    },
  };
}

export function getAbTestFeatureStartedAt(abTest) {
  return abTest?.publishedAt ?? abTest?.createdAt ?? null;
}

export function getPickerDateRange({ dateRange, getConvertedDateRange, resolverOptions }) {
  if (!dateRange) return null;

  if (dateRange.special) {
    if (!isValidAbTestSpecialDateRange(dateRange.special)) return null;

    const specialDateRange = getConvertedDateRange({ special: dateRange.special }, resolverOptions);

    if (!specialDateRange) return null;

    return {
      start_date: fromUnixTime(specialDateRange.startDate),
      end_date: fromUnixTime(specialDateRange.endDate),
    };
  }

  if (!dateRange.start_date || !dateRange.end_date) return null;

  return dateRange;
}
